module.exports = __webpack_public_path__ + "img/bacon.822db2c9.jpg";